import { useEffect, useState } from 'react'

export const convertFileToBase64 = (file) => {
  return new Promise((resolve) => {
    if (!file) {
      resolve('')
      return
    }
    const reader = new FileReader()
    reader.addEventListener('loadend', () => {
      resolve(`data:${file.type};base64,${btoa(reader.result)}`)
    })
    reader.readAsBinaryString(file)
  })
}

export const useFileToBase64 = (file) => {
  const [preview, setPreview] = useState('')

  useEffect(() => {
    convertFileToBase64(file).then(setPreview)
  }, [file])

  return preview
}
